// src/components/addresspage/LocationPicker.jsx
import React, { useEffect, useState } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { X } from "lucide-react";
import "./locationPicker.css"; // optional, or inline styles

const containerStyle = {
  width: "100%",
  height: "400px",
};

const LocationPicker = ({
  isOpen,
  onClose,
  onLocationSelect,
  initialLocation,
}) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API,
  });

  const [position, setPosition] = useState(
    initialLocation || {
      lat: 19.071753351870193,
      lng: 73.00916993454287,
    }
  );

  // Auto-detect user location when modal opens
  useEffect(() => {
    if (!isOpen) return;

    if (initialLocation) {
      setPosition(initialLocation);
      return;
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setPosition({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          });
        },
        () => {
          // If user denies, fall back to store location
          setPosition({
            lat: 19.071753351870193,
            lng: 73.00916993454287,
          });
        }
      );
    }
  }, [isOpen, initialLocation]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    onLocationSelect(position); // {lat, lng}
  };

  return (
    <div className="lp-overlay">
      <div className="lp-modal">
        <div className="lp-header">
          <h2>Select Delivery Location</h2>
          <button className="lp-close-btn" onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        <p className="lp-subtitle">
          We auto-detected your location. Drag the pin to your exact house / building.
        </p>

        {isLoaded ? (
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={position}
            zoom={15}
            onClick={(e) =>
              setPosition({
                lat: e.latLng.lat(),
                lng: e.latLng.lng(),
              })
            }
          >
            <Marker
              position={position}
              draggable={true}
              onDragEnd={(e) =>
                setPosition({
                  lat: e.latLng.lat(),
                  lng: e.latLng.lng(),
                })
              }
            />
          </GoogleMap>
        ) : (
          <div style={{ padding: "20px", textAlign: "center" }}>
            Loading map...
          </div>
        )}

        <div className="lp-footer">
          <div className="lp-coordinates">
            <span>Latitude: {position.lat.toFixed(6)}</span>
            <span>Longitude: {position.lng.toFixed(6)}</span>
          </div>
          <button className="lp-confirm-btn" onClick={handleConfirm}>
            Use this location
          </button>
        </div>
      </div>
    </div>
  );
};

export default LocationPicker;
